import { render, staticRenderFns } from "./RemindHistoryList.vue?vue&type=template&id=3c2673bc&scoped=true&"
import script from "./RemindHistoryList.vue?vue&type=script&lang=js&"
export * from "./RemindHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./RemindHistoryList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RemindHistoryList.vue?vue&type=style&index=1&id=3c2673bc&lang=scss&scoped=true&"
import style2 from "./RemindHistoryList.vue?vue&type=style&index=2&id=3c2673bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2673bc",
  null
  
)

export default component.exports